'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _optInFeedback = require('../../opt-in-feedback');

var _optInFeedback2 = _interopRequireDefault(_optInFeedback);

var _optInFeedbackSuccessMessage = require('../../opt-in-feedback-success-message');

var _optInFeedbackSuccessMessage2 = _interopRequireDefault(_optInFeedbackSuccessMessage);

var _optInPrompt = require('../../opt-in-prompt');

var _optInPrompt2 = _interopRequireDefault(_optInPrompt);

require('../styles/OptInBanner.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  allowOptOut: _react.PropTypes.bool,
  allowDismiss: _react.PropTypes.bool,
  bundle: _react.PropTypes.string.isRequired,
  optedIn: _react.PropTypes.bool,
  actions: _react.PropTypes.object.isRequired,
  feedbackOpen: _react.PropTypes.bool,
  feedbackCategory: _react.PropTypes.string.isRequired,
  showFeedbackSuccess: _react.PropTypes.bool,
  showAdditionalMessage: _react.PropTypes.bool,
  isLoading: _react.PropTypes.bool,
  location: _react.PropTypes.object
};

var OptInBanner = function (_BcReactComponent) {
  _inherits(OptInBanner, _BcReactComponent);

  function OptInBanner(props) {
    _classCallCheck(this, OptInBanner);

    var _this = _possibleConstructorReturn(this, (OptInBanner.__proto__ || Object.getPrototypeOf(OptInBanner)).call(this, props));

    _this.bindAll('closeFeedbackSuccessMessage', 'dismissOptIn', 'openFeedbackForm', 'optOut', 'optIn', 'closeFeedbackForm');
    return _this;
  }

  _createClass(OptInBanner, [{
    key: 'renderFeedbackForm',
    value: function renderFeedbackForm() {
      if (this.props.feedbackOpen) {
        return _react2.default.createElement(_optInFeedback2.default, {
          feedbackCategory: this.props.feedbackCategory,
          bundle: this.props.bundle,
          closeFeedbackForm: this.closeFeedbackForm,
          handleSubmit: this.props.actions.submitFeedback,
          isLoading: this.props.isLoading });
      }

      return _react2.default.createElement('noop', null);
    }
  }, {
    key: 'closeFeedbackForm',
    value: function closeFeedbackForm() {
      this.props.actions.closeFeedbackForm(this.props.bundle);
    }
  }, {
    key: 'closeFeedbackSuccessMessage',
    value: function closeFeedbackSuccessMessage() {
      this.props.actions.closeFeedbackSuccessMessage(this.props.bundle);
    }
  }, {
    key: 'dismissOptIn',
    value: function dismissOptIn() {
      this.props.actions.dismissOptIn(this.props.bundle);
    }
  }, {
    key: 'openFeedbackForm',
    value: function openFeedbackForm() {
      this.props.actions.openFeedbackForm(this.props.bundle);
    }
  }, {
    key: 'optOut',
    value: function optOut() {
      this.props.actions.optOut(this.props.bundle, _lodash2.default.pick(this.props.location, ['pathname', 'query']));
    }
  }, {
    key: 'optIn',
    value: function optIn() {
      this.props.actions.optIn(this.props.bundle);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          bundle = _props.bundle,
          optedIn = _props.optedIn,
          showFeedbackSuccess = _props.showFeedbackSuccess,
          showAdditionalMessage = _props.showAdditionalMessage,
          allowOptOut = _props.allowOptOut,
          allowDismiss = _props.allowDismiss;

      if (showFeedbackSuccess) {
        return _react2.default.createElement(_optInFeedbackSuccessMessage2.default, { close: this.closeFeedbackSuccessMessage });
      }

      return _react2.default.createElement(
        'div',
        { className: 'cp-opt-in-banner bg-info clearfix' },
        _react2.default.createElement(_optInPrompt2.default, {
          optedIn: optedIn,
          bundle: bundle,
          allowOptOut: allowOptOut,
          allowDismiss: allowDismiss,
          showAdditionalMessage: showAdditionalMessage,
          handleDismiss: this.dismissOptIn,
          handleOpenFeedback: this.openFeedbackForm,
          handleOptOut: this.optOut,
          handleOptIn: this.optIn }),
        this.renderFeedbackForm()
      );
    }
  }]);

  return OptInBanner;
}(_baseBcReactComponent2.default);

OptInBanner.propTypes = propTypes;

exports.default = OptInBanner;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/opt-in/lib/components/opt-in-banner/components/OptInBanner.component.js
// module id = 1434
// module chunks = 1